import debug from 'debug';

import { LogService } from './LogService';

const log = debug('LogService:Report');

export class Report extends LogService {
	
	// Log that the user navigated from search to a catalog
	ContentBlocker() {
		this.LaunchDarklyFeature().then(() => {
			let url = '/api/web/logreportcontentblocker';
			let body = this.settings;
	
			body.contentBlocker = true;
			this.Post({
				url: url,
				body: body
			})
		});
	}
}

export let report = new Report();
